<script setup>
/**
 * FormControlAccountSettingsPrimaryDomain
 * Replaces 'extends: FormControlTypeText' with Composition.
 * Validates that the primary domain does not use restricted system domains.
 */
import { watch, getCurrentInstance } from 'vue';
import FormControlTypeText from '../form-control-type/FormControlTypeText.vue';

const props = defineProps({
    // Standard Orchestrator Props - Must be explicit to replace 'extends'
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
});

const { proxy } = getCurrentInstance();

// --- Methods ---

/**
 * Syncs the error message to the field object and the native DOM element
 * @param {string} msg
 */
const validate = (msg) => {
    props.field.error = msg;

    /**
     * Access the base component's internal ref.
     * Requirement: FormControlTypeText must have ref="field" on its input.
     */
    const el = proxy.$refs.baseControl?.$refs.field;

    if (el) {
        el.setCustomValidity(msg);
        el.checkValidity();
    }
};

// --- Watchers ---

watch(() => props.value, (newValue) => {
    validate('');

    const restrictedDomains = [
        'creativecms.io'
    ];

    restrictedDomains.forEach((domain) => {
        if (newValue && newValue.includes(domain)) {
            const msg = `<strong>${domain}</strong> domains may not be used.`;
            validate(msg);
        }
    });
}, { immediate: true });
</script>

<template>
    <FormControlTypeText
        ref="baseControl"
        v-bind="$props"
        v-on="$listeners"
    />
</template>

<style scoped>
/* Scoped styles inherited from base or local overrides */
</style>